/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Back_TitleInputs */

const fr_welcome_back_title = /** @type {(inputs: Welcome_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur la nouvelle version`)
};

const en_welcome_back_title = /** @type {(inputs: Welcome_Back_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to the new version`)
};

/**
* | output |
* | --- |
* | "Welcome to the new version" |
*
* @param {Welcome_Back_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const welcome_back_title = /** @type {((inputs?: Welcome_Back_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome_back_title(inputs)
	return en_welcome_back_title(inputs)
});